import React from 'react';
import { Link } from 'react-router-dom';
import { Languages, Twitter, Instagram, Linkedin } from 'lucide-react';

const Footer = () => {
    return (
        <footer className="bg-slate-800 text-slate-400 py-10">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid md:grid-cols-4 gap-8 mb-8">
                    <div>
                        <div className="flex items-center gap-2 mb-4">
                            <img src="/logo192.png" alt="CeviriPro Logo" className="w-8 h-8 object-contain drop-shadow-sm" />
                            <span className="text-lg font-bold text-gradient-blue">
                                ÇeviriPro
                            </span>
                        </div>
                        <p className="text-sm leading-relaxed text-slate-500">
                            Belgelerinizi saniyeler içinde 100'den fazla dile çevirin.
                        </p>
                        <div className="flex gap-2 mt-4">
                            <a href="#" className="w-8 h-8 bg-slate-700 rounded-lg flex items-center justify-center hover:bg-blue-500/30 transition-all">
                                <Twitter className="w-4 h-4" />
                            </a>
                            <a href="#" className="w-8 h-8 bg-slate-700 rounded-lg flex items-center justify-center hover:bg-blue-500/30 transition-all">
                                <Instagram className="w-4 h-4" />
                            </a>
                            <a href="#" className="w-8 h-8 bg-slate-700 rounded-lg flex items-center justify-center hover:bg-blue-500/30 transition-all">
                                <Linkedin className="w-4 h-4" />
                            </a>
                        </div>
                    </div>
                    <div>
                        <h4 className="text-white font-medium mb-4">Ürün</h4>
                        <ul className="space-y-2 text-sm">
                            <li><Link to="/ozellikler" className="hover:text-blue-400 transition-colors">Özellikler</Link></li>
                            <li><Link to="/#desteklenen-formatlar" className="hover:text-blue-400 transition-colors">Formatlar</Link></li>
                            <li><Link to="/blog" className="hover:text-blue-400 transition-colors">Blog</Link></li>
                        </ul>
                    </div>
                    <div>
                        <h4 className="text-white font-medium mb-4">Kurumsal</h4>
                        <ul className="space-y-2 text-sm">
                            <li><Link to="/hakkimizda" className="hover:text-blue-400 transition-colors">Hakkımızda</Link></li>
                            <li><Link to="/sss" className="hover:text-blue-400 transition-colors">SSS</Link></li>
                            <li><Link to="/iletisim" className="hover:text-blue-400 transition-colors">İletişim</Link></li>
                        </ul>
                    </div>
                    <div>
                        <h4 className="text-white font-medium mb-4">Giriş</h4>
                        <ul className="space-y-2 text-sm">
                            <li><Link to="/login" className="hover:text-blue-400 transition-colors">Giriş Yap</Link></li>
                            <li><Link to="/register" className="hover:text-blue-400 transition-colors">Kaydol</Link></li>
                        </ul>
                    </div>
                </div>
                <div className="border-t border-slate-700 pt-6 text-sm text-center text-slate-500">
                    <p>© 2026 ÇeviriPro. Tüm hakları saklıdır.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
